// True for iOS/iPadOS. iPadOS Safari reports a Mac UA, so a Mac with a touchscreen = an iPad.
export const isIOS = () => {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || "";
  const appleMobileUA = /iPad|iPhone|iPod/.test(ua);
  const iPadOSAsMac = navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
  return appleMobileUA || iPadOSAsMac;
};
